// Shared display helpers for the Chargebacks list + detail pages (PROD-7808).

// Currencies whose minor unit is not 1/100 (mirrors the goserver fmtAmount, plan R15).
export const CURRENCY_DECIMALS = {
  jpy: 0,
  krw: 0,
  vnd: 0,
  clp: 0,
  xof: 0,
  xaf: 0,
  kwd: 3,
  bhd: 3,
  omr: 3,
  tnd: 3
};

// fmt_amount renders raw Stripe minor units in the currency's real precision.
export const fmt_amount = (minor, code) => {
  const d = CURRENCY_DECIMALS[(code || '').toLowerCase()] ?? 2;
  const value = d === 0 ? minor || 0 : (minor || 0) / 10 ** d;
  return `${d === 0 ? value : value.toFixed(d)} ${(code || '').toUpperCase()}`;
};

// lost_status_label: internal_status → the human phrase shown on lost-chargeback banners.
export const lost_status_label = (internal_status) => {
  const s = String(internal_status || '').toUpperCase();
  if (s === 'RESOLVED') return 'resolved';
  if (s === 'NO_ACTION') return 'reviewed, no action';
  return 'action pending';
};

// select_lost_banner picks the most recent lost dispute (+ how many more) for the
// student-profile banner; null = no banner. Pure so it's unit-testable (PROD-7808 T6).
export const select_lost_banner = (rows) => {
  const lost = (Array.isArray(rows) ? rows : []).filter(
    (r) => r && String(r.status || '').toLowerCase() === 'lost'
  );
  if (lost.length === 0) return null;
  const sorted = [...lost].sort(
    (a, b) => new Date(b.stripe_created_date || 0) - new Date(a.stripe_created_date || 0)
  );
  return {
    dispute: sorted[0],
    extra_count: lost.length - 1,
    status_label: lost_status_label(sorted[0].internal_status)
  };
};

// status_badge maps a dispute/EFW status to theme-token badge colors (never hardcode colors).
export const status_badge = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'lost' || s === 'charge_refunded') {
    return { background: 'var(--state-error-bg)', color: 'var(--state-error-text)' };
  }
  if (s === 'won') {
    return { background: 'var(--state-success-bg)', color: 'var(--state-success-text)' };
  }
  if (s.includes('needs_response') || s === 'actionable') {
    return { background: 'var(--state-warning-bg)', color: 'var(--state-warning-text)' };
  }
  return { background: 'var(--state-info-bg)', color: 'var(--state-info-text)' };
};
